import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { LookInside } from '@/components/LookInside';
import { usePageData } from '@/contexts/pageContext';

const jellybooksPortal = document.querySelector('.product__look-inside');

export const useJellybooks = () => {
  const { product } = usePageData();

  const url = product?.jellybooksUrl;
  const isInitialised = useRef(false);

  useEffect(() => {
    if (isInitialised.current) {
      return;
    }

    if (window.excerpts) {
      window.excerpts.init();
      isInitialised.current = true;
    }
  }, []);

  return jellybooksPortal && url
    ? createPortal(<LookInside url={url} />, jellybooksPortal)
    : null;
};
